const staticRoot = process.env.STATIC_ROOT || '/assets';

module.exports = {
  // Default variables required by the application, but not in environment (see below)
  default: {
    ASSETS_ROOT: `${staticRoot}/webapp-assets`,
    MEDIA_ROOT: `${staticRoot}/webapp-media`,
    UPLOAD_ROOT: `${staticRoot}/uploads`,
    NODE_ENV: 'production',
    SERVER_PORT: 3000,
  },
  // These are environment variables required at runtime, by either or both the Node and React apps
  // All variables are taken from the environment and configured into a single object exported below
  // Public variables are instantiated into global scope by config/globals.js, and rendered in HTML
  // Private variables (secrets) are accessible (e.g. config.SECRET) but are not send over the wire
  public: [
    'AUTH0_CLIENT_DOMAIN',
    'AUTH0_CLIENT_ID',
    'ASSETS_ROOT',
    'BRAZE_API_KEY',
    'BRAZE_BASE_URL',
    'FACEBOOK_APP_ID',
    'GA_TRACKING_ID',
    'GMAPS_API_KEY',
    'GMAPS_STATIC_API_KEY',
    'GQL_ROOT',
    'GQL_ROOT_EXTERNAL',
    'USER_ROOT_EXTERNAL',
    'INTEGRATION_SERVICE_ROOT_EXTERNAL',
    'INTERCOM_APP_ID',
    'IPSTACK_API_KEY',
    'LDT_ENV',
    'MAPBOX_API_KEY',
    'MEDIA_ROOT',
    'MESSAGE_PUBLISHER_AWS_ACCESS_KEY_ID',
    'MESSAGE_PUBLISHER_AWS_SECRET_ACCESS_KEY',
    'MESSAGE_PUBLISHER_AWS_REGION',
    'MESSAGE_PUBLISHER_QUEUE',
    'POSTCODER_API_KEY',
    'SEGMENT_ID',
    'SENTRY_WEB_DSN',
    'STRIPE_CLIENT_ID',
    'STRIPE_PUBLIC_KEY',
    'UPLOAD_ROOT',
    'WEB_ROOT',
    'COGNITO_CALLBACK_PATH',
    'COGNITO_BASE_URL',
    'COGNITO_CLIENT_ID',
  ],
  private: ['STRIPE_CLIENT_SECRET'],
};
